import { api } from "./client";

export interface UserRead {
  id: string;
  clinic_id: string;
  email: string;
  full_name: string;
  role: "admin" | "registrar" | "doctor" | "lab_tech" | "chief_doctor" | "medical_commission";
  specialty: string | null;
  is_active: boolean;
  must_change_password: boolean;
  last_login_at: string | null;
}

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_at: string;
  user: UserRead;
  permissions: string[];
}

export interface MeResponse {
  user: UserRead;
  permissions: string[];
}

export async function login(input: {
  email: string;
  password: string;
}): Promise<TokenResponse> {
  const { data } = await api.post<TokenResponse>("/auth/login", input);
  return data;
}

export async function refresh(refreshToken: string): Promise<TokenResponse> {
  const { data } = await api.post<TokenResponse>("/auth/refresh", {
    refresh_token: refreshToken,
  });
  return data;
}

export async function logout(refreshToken: string): Promise<void> {
  await api.post("/auth/logout", { refresh_token: refreshToken });
}

export async function getMe(): Promise<MeResponse> {
  const { data } = await api.get<MeResponse>("/auth/me");
  return data;
}

export async function changePassword(input: {
  current_password: string;
  new_password: string;
}): Promise<void> {
  await api.post("/auth/change-password", input);
}

export async function updateMe(input: { full_name?: string }): Promise<MeResponse> {
  const { data } = await api.patch<MeResponse>("/auth/me", input);
  return data;
}
